<template>
  <section>
    <div class="pop-room material-detail-pop" v-if="detailStatus">
      <a href="javascript:;" @click="closeDetailStatus()" class="iconfont icon-close"></a>
      <div class="pop-cont">

        <h3 class="title">
          材料入库单
          <span style="margin-left:10px;position:relative;top:-3px;">
            <a v-if="!isMobile" :href="baseURL + '/storage/material/in/download?inId=' + materialInData.id"
              target="_blank">
              <!-- 负责人、审批人、管理员可以下载 -->
              <!-- SYSTEM_2 单独设置的下载权限 -->
              <el-button type="success" icon="el-icon-download" size="mini">表格下载</el-button>
            </a>

            <!-- 打印 -->
            <el-button @click="print()" type="primary" icon="el-icon-printer" size="mini">打印格式</el-button>
          </span>
        </h3>


        <el-col :span="23" v-if="materialInData">
          <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;">
            <el-form-item label="供应商:">
              {{materialInData.supplier?materialInData.supplier.name:''}}
            </el-form-item>
            <el-form-item label="发票号码:">
              {{materialInData.inVoice}}
            </el-form-item>
            <el-form-item label="入库操作员:">
              <user-info :userData='materialInData.creator'></user-info>
            </el-form-item>
            <el-form-item label="入库确认员:">
              <user-info :userData='materialInData.priceUser'></user-info>
            </el-form-item>
            <el-form-item label="入库时间:">
              {{materialInData.time}}
            </el-form-item>
            <el-form-item label="总金额(元):">
              {{materialInData.zjTotal}}
            </el-form-item>
            <el-form-item class="full" label="材料明细:">
              <div class="material-table">
                <el-table :data="materialInData.materials" border>
                  <el-table-column prop="number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="name" label="明细名称" width="240">
                  </el-table-column>
                  <el-table-column prop="dlName" label="材料类别" width="200">
                  </el-table-column>
                  <el-table-column prop="unitName" align="center" label="计量单位">
                  </el-table-column>
                  <el-table-column prop="" align="center" label="数量">
                    <template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="" align="center" label="单价(元)">
                    <template slot-scope="scope">
                      {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalPrice" align="center" label="总价(元)">
                  </el-table-column>
                </el-table>

                <div class="table-total">
                  <span>数量：{{ materialInData.slTotal }} 件</span>
                  <span>总金额：{{ materialInData.zjTotal }} 元</span>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    computed: {
      ...mapState({
        isMobile: state => state.main.isMobile,
      })
    },
    components: {
      UserInfo,
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,
      }
    },
    props: ['detailStatus', 'materialInData'],
    methods: {
      // 打印
      print() {
        let _printData = {
          type: 'materialIn',
          data: this.materialInData,
          isPrint: true,
        }
        this.$store.commit('set_printData', _printData)
      },
      closeDetailStatus() {
        this.$emit("hideDetail")
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/components/materialInDetail.vue